const CONSENT_KEY = "nexmoov_cookie_consent";
const CONSENT_EVENT = "nexmoov:cookie-consent";
const config = window.nmGtmConfig || {};

let scheduled = false;
let loaded = false;

const hasConsent = () => {
    try {
        return window.localStorage?.getItem(CONSENT_KEY) === "accepted";
    } catch (error) {
        return false;
    }
};

const loadGtm = () => {
    const containerId = String(config.containerId || "");
    if (loaded || !hasConsent() || !/^GTM-[A-Z0-9]+$/.test(containerId)) return;

    loaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag("consent", "default", {
        analytics_storage: "granted",
        ad_storage: "granted",
    });
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
    document.head.appendChild(script);
};

const scheduleGtm = () => {
    if (scheduled || loaded || !hasConsent()) return;
    scheduled = true;

    requestAnimationFrame(() => {
        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(loadGtm, { timeout: 2500 });
            return;
        }

        window.setTimeout(loadGtm, 0);
    });
};

if (hasConsent()) scheduleGtm();

window.addEventListener(CONSENT_EVENT, (event) => {
    if (event?.detail?.value === "accepted") scheduleGtm();
});
